// Helper functions for storing and retrieving prohibited query parameters as cookies

import { getCookieByName, setCookie } from './cookie_utils'

const COOKIE_PREFIX = 'bb_'

// Set during init so getter functions know which params to read
let prohibitedParams: string[] = []

const storeProhibitedQueryParamsAsCookies = (params: string[]) => {
  prohibitedParams = params
  const currentQueryParams = new URLSearchParams(window.location.search)

  params.forEach((param) => {
    const value = currentQueryParams.get(param)
    if (!value) return
    setCookie(`${COOKIE_PREFIX}${param}`, value)
  })
}

const clearQueryParameters = (params: string[]) => {
  const queryParams = new URLSearchParams(window.location.search)

  params.forEach((param) => {
    queryParams.delete(param)
  })

  history.replaceState(
    null,
    '',
    `${window.location.pathname}?${queryParams.toString()}`,
  )
}

export const getQueryParametersString = () => {
  const params = new URLSearchParams()
  prohibitedParams.forEach((param) => {
    const value = getCookieByName(`${COOKIE_PREFIX}${param}`)
    if (value) params.set(param, value)
  })
  return params.toString()
}

export const getQueryParametersDict = () => {
  const searchParams = new URLSearchParams(window.location.search)
  return Object.fromEntries(searchParams.entries())
}

export const storeAndClearProhibitedQueryParams = (params: string[]) => {
  storeProhibitedQueryParamsAsCookies(params)
  clearQueryParameters(params)
}

export const getFullUrlWithProhibitedParams = () => {
  const url = new URL(window.location.href)
  prohibitedParams.forEach((param) => {
    const value = getCookieByName(`${COOKIE_PREFIX}${param}`)
    if (value && !url.searchParams.has(param)) {
      url.searchParams.set(param, value)
    }
  })
  return url.toString()
}
